import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Spinner, Alert } from 'react-bootstrap';
import { get } from '../../services/Services';
import { diploma_Base64 } from '../EventOrganization/Certificates/diploma_base64.js';
import { jsPDF } from 'jspdf';
import { Table, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { useAuthProvider } from "../../customHooks/authContext";
const Certificates = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showCertModal, setShowCertModal] = useState(false);
  const [certType, setCertType] = useState({ participation: false, choreography: false });
  const [totalCertificates, setTotalCertificates] = useState(0);
  const [selectedEventData, setSelectedEventData] = useState(null);
  const [selectedRegistration, setSelectedRegistration] = useState(null);
  const { school, token } = useAuthProvider();
  const schoolId = school?.id;
  useEffect(() => {
    const fetchEventsBySchool = async () => {
      try {
        //const schoolid = schoolId; // 🔁 Acá colocá el ID real o pasalo como prop/estado
        const response = await get(`https://ectech-software.com.ar/api/academy/schools/${schoolId}/events`);
        const schoolEvents = response.data;
        setEvents(schoolEvents);
      } catch (err) {
        console.error("Error al cargar eventos de la escuela:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchEventsBySchool();
  }, []);



  const handlePrintCertification = async (config_Id, Id, event_id, certType) => {
    try {
      let url = `https://ectech-software.com.ar/api/academy/events/${config_Id}/performances/awards?event_registration_id=${Id}`;

      if (certType === 'choreography') {
        url += `&is_choreographed=true`;
      }

      const response = await get(url);
      const data = response.data;

      if (!Array.isArray(data) || data.length === 0) {
        alert("No hay datos disponibles para generar certificados.");
        return;
      }

      const eventResponse = await get(
        `https://ectech-software.com.ar/api/academy/events/${event_id}`
      );
      const eventInfo = eventResponse.data;
      const eventName = eventInfo?.name || "Nombre del evento";



      const formatDateLongSpanish = (dateStr) => {
        if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
          // Si no es fecha válida en formato YYYY-MM-DD, devolvemos el texto tal cual
          return dateStr;
        }
        const [year, month, day] = dateStr.split("-");
        const localDate = new Date(`${year}-${month}-${day}T00:00:00`);

        return localDate.toLocaleDateString("es-ES", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      };
      const eventEndDate = formatDateLongSpanish(eventInfo?.config?.eventEndDate || "Fecha no disponible");
      const eventCity = eventInfo?.config?.city.name || "";
      const eventCompetitionNumber = eventInfo?.config?.competitionNumber || "";
      const eventChoreographers = eventInfo?.config?.choreographers || "";

      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
      let pageCount = 0;



      data.forEach((performance) => {
        const {
          members,
          awards,
          modality,
          category,
          dancePerformance,
          choreographers,
          competitionNumber,
          city
        } = performance;



        if (!Array.isArray(awards) || awards.length === 0) return;

        if (certType === 'choreography') {
          // ✅ Solo premios que contengan "coreografía"
          awards
            .filter(a => a.name.toLowerCase().includes("coreografía"))
            .forEach((award) => {
              if (pageCount > 0) doc.addPage();
              doc.addImage(diploma_Base64, 'PNG', 0, 0, 297, 210); // A4 landscape
              const nameToShow = Array.isArray(choreographers) && choreographers.length > 0
                ? choreographers.join(" y ")
                : "Nombre del Coreógrafo";
              //Certificamos que 
              doc.setFont("cambria", "normal");
              doc.setFontSize(24);
              doc.text("Certificamos a", 148, 45, { align: "center" });

              //Nombre de alumno - profesor - preparador
              doc.setFont('Playball-Regular', 'bolditalic');
              doc.setFontSize(50);
              doc.setTextColor('AB8E5B');
              doc.text(nameToShow.trim(), 148, 65, { align: "center" });

              //participo del 
              doc.setFont("cambria", "normal");
              doc.setFontSize(23);
              doc.setTextColor('#000000');
              doc.text(`Participó del ${competitionNumber} Certamen`, 148, 80, { align: "center" });

              //Nombre del evento 
              doc.setFont('Playball-Regular', 'bolditalic');
              doc.setFontSize(58);
              doc.text(`${eventName}`, 148, 100, { align: "center" });

              //modalidad y obra
              doc.setFont("cambria", "normal");
              doc.setFontSize(23);
              doc.text(`Modalidad ${modality || ""} - ${category || ""}`, 148, 115, { align: "center" });
              doc.text(`con la obra: ${dancePerformance || "Obra sin título"}`, 148, 126, { align: "center", });

              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`SANCHEZ PATRICIA`, 60, 168, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`ABUT SAMIR`, 125, 170, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`GUSTAVO BERTUOL`, 190, 170, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`SILVERA MARIA CRISTINA`, 245, 168, { align: "center" });

              //Premio
              doc.setFont('Playball-Regular', 'bolditalic');
              doc.setFontSize(36);
              doc.text(award.name, 148, 144, { align: "center" });

              //Ciudad y fecha
              doc.setFont("cambria", "normal");
              doc.setFontSize(14);
              doc.text(`${eventCity}, ${eventEndDate}`, 148, 200, {
                align: "center",
              });

              pageCount++;
            });
        }
        else if (certType === 'preparer') {
          const award = awards.find(a => !a.name.toLowerCase().includes("coreografía"));
          if (!award || !Array.isArray(performance.preparers) || performance.preparers.length === 0) return;

          performance.preparers.forEach((preparer) => {
            if (typeof preparer !== "string") return;

            if (pageCount > 0) doc.addPage();
            doc.addImage(diploma_Base64, 'PNG', 0, 0, 297, 210); // A4 landscape
            //Certificamos que 
            doc.setFont("cambria", "normal");
            doc.setFontSize(24);
            doc.text("Certificamos que", 148, 45, { align: "center" });

            //Profesor - Preparador - Alumno
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(50);
            doc.setTextColor('AB8E5B');
            doc.text(`Prof. ${preparer.trim()}`, 148, 65, { align: "center" });

            //Participó del 
            doc.setFont("cambria", "normal");
            doc.setFontSize(23);
            doc.setTextColor('#000000');
            doc.text(`Participó del ${competitionNumber} Certamen`, 148, 80, { align: "center" });

            //Nombre del evento
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(58);
            doc.text(`${eventName}`, 148, 100, { align: "center" });

            //Modalidad  - obra
            doc.setFont("cambria", "normal");
            doc.setFontSize(23);
            doc.text(`Modalidad ${modality || ""} - Categoría ${category || ""}`, 148, 115, { align: "center" });
            doc.text(`con la obra: ${dancePerformance || "Obra sin título"}`, 148, 126, { align: "center", });

            //Jurados
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`SANCHEZ PATRICIA`, 60, 168, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`ABUT SAMIR`, 125, 170, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`GUSTAVO BERTUOL`, 190, 170, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`SILVERA MARIA CRISTINA`, 245, 168, { align: "center" });

            //Premios
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(36);
            doc.text(award.name, 148, 144, { align: "center" });

            //Ciudad y fecha
            doc.setFont("cambria", "normal");
            doc.setFontSize(14);
            doc.text(`${eventCity}, ${eventEndDate}`, 148, 200, {
              align: "center",
            });

            pageCount++;
          });
        }

        else {
          if (!Array.isArray(members) || members.length === 0) return;

          // ❗ Solo usamos el primer premio que NO sea de coreografía
          const award = awards.find(a => !a.name.toLowerCase().includes("coreografía"));
          if (!award) return;

          members.forEach((member) => {
            if (typeof member !== "string") return;

            if (pageCount > 0) doc.addPage();
            doc.addImage(diploma_Base64, 'PNG', 0, 0, 297, 210); // A4 landscape

            //certificamos que 
            doc.setFont("cambria", "normal");
            doc.setFontSize(24);
            doc.text("Certificamos que", 148, 45, { align: "center" });

            //Profesores - Alumnos - preparadores
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(50);
            doc.setTextColor('AB8E5B');
            doc.text(member.trim(), 148, 65, { align: "center" });

            //Participo del 
            doc.setFont("cambria", "normal");
            doc.setFontSize(23);
            doc.setTextColor('#000000');
            doc.text(`Participó del ${eventCompetitionNumber} Certamen`, 148, 80, { align: "center" });

            //Evento
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(58);
            doc.text(`${eventName}`, 148, 100, { align: "center" });

            //Modalidad - con la obra
            doc.setFont("cambria", "normal");
            doc.setFontSize(23);
            doc.text(`En la modalidad ${modality || ""} ${category ? `${category}` : ""}`, 148, 115, { align: "center" });
            doc.text(`con la obra: ${dancePerformance || "Obra sin título"}`, 148, 126, { align: "center", });

            //Jurados
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`SANCHEZ PATRICIA`, 60, 168, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`ABUT SAMIR`, 125, 170, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`GUSTAVO BERTUOL`, 190, 170, { align: "center" });
              doc.setFont("cambria", "normal");
              doc.setFontSize(12);
              doc.text(`SILVERA MARIA CRISTINA`, 245, 168, { align: "center" });

            //premio
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(36);
            doc.text(award.name, 148, 144, { align: "center" });

            //Ciudad - fecha
            doc.setFont("cambria", "normal");
            doc.setFontSize(14);
            doc.text(`${eventCity}, ${eventEndDate}`, 148, 200, {
              align: "center",
            });

            pageCount++;
          });
        }

      });

      doc.save("certificados_personalizados.pdf");
    } catch (error) {
      console.error("Error al generar certificados:", error);
      alert("Error al generar certificados: " + error.message);
    }
  };

  return (
    <Container className="mt-4 pb-5">
      <h2 className="text-center fw-bold text-primary mb-4">Certificados</h2>

      <Row className="align-items-center mb-3">
        <Col xs={12} md={8}>

          <Form.Select
            onChange={(e) => {
              const selectedConfigId = parseInt(e.target.value);
              const reg = events.find(ev => ev.eventConfigId === selectedConfigId);
              if (reg) {
                setSelectedRegistration({
                  config_id: reg.eventConfigId,
                  id: reg.eventRegistrationId,
                  event_id: reg.eventId,
                });
              }
            }}
            defaultValue=""
          >
            <option value="" disabled>Seleccionar evento</option>
            {events.map((ev) => (
              <option key={ev.eventConfigId} value={ev.eventConfigId}>
                {ev.name} - {new Date(ev.date).getFullYear()}
              </option>
            ))}
          </Form.Select>

        </Col>

        <Col xs={12} md={4} className="mt-3 mt-md-0 text-md-start text-center">
          <Button
            variant="success"
            size="sm"
            className="me-1 small"
            onClick={() => {
              if (selectedRegistration) {
                setShowCertModal(true);
              } else {
                alert("Por favor seleccioná un evento primero.");
              }
            }}
          >
            Generar Certificados
          </Button>

        </Col>
      </Row>

      <Modal show={showCertModal} onHide={() => setShowCertModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Seleccionar tipo de certificado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Check
              type="checkbox"
              label="Por participación"
              checked={certType.participation}
              onChange={(e) =>
                setCertType((prev) => ({ ...prev, participation: e.target.checked }))
              }
            />
            <Form.Check
              type="checkbox"
              label="Por coreografía"
              checked={certType.choreography}
              onChange={(e) =>
                setCertType((prev) => ({ ...prev, choreography: e.target.checked }))
              }
            />
            <Form.Check
              type="checkbox"
              label="Para Maestros Preparadores"
              checked={certType.preparer}
              onChange={(e) =>
                setCertType((prev) => ({ ...prev, preparer: e.target.checked }))
              }
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCertModal(false)}>
            Cancelar
          </Button>
          <Button
  variant="primary"
  onClick={() => {
    if (!selectedRegistration) return;

    const { config_id, id, event_id } = selectedRegistration;

    if (certType.participation) {
      handlePrintCertification(config_id, id,event_id, 'participation');
    }
    if (certType.choreography) {
      handlePrintCertification(config_id, id,event_id,  'choreography');
    }
    if (certType.preparer) {
      handlePrintCertification(config_id, id, event_id, 'preparer');
    }

    setShowCertModal(false);
    setCertType({ participation: false, choreography: false, preparer: false });
  }}
>
  Generar
</Button>


        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Certificates;
